import * as actionTypes from '../actions/actionTypes';

const initialState = {
  refresh: false,
  uploadActivityCode: null

};

const BulkUploadReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.REFRESH_IFRAME:
      return { ...state, refresh: !state.refresh };

    case actionTypes.UPLOAD_ACTIVITY_CODE:
      return { ...state, uploadActivityCode: action.payload };

    default:
      return state;
  }
};

export default BulkUploadReducer;